<template>

    <v-list-item>
        <span>{{ member.name | truncate(30) }}<br><span class="small"><a :href="'mailto:' + member.email">{{ member.email | truncate(30) }}</a></span></span>
        <div class="grid">
            <span class="small">{{ member.role.name }}</span>
            <span class="small" :class="{ 'text-danger': !member.authy_activated_at, 'text-success': member.authy_activated_at }">{{ member.authy_activated_at ? '2FA Enabled' : '2FA Not Enabled' }}</span>
            <div><v-button class="float-right" size="sm" btn-style="secondary" @click.native="editMember">Edit</v-button></div>
        </div>
    </v-list-item>

</template>

<script>

export default {

    props: {
        member: {
            type: Object,
            required: true,
        },
    },

    methods: {

        editMember() {
            this.$router.push({
                name: 'members-edit',
                params: { member_id: this.member.id }
            });
        },

    },

}

</script>
